import React from 'react';
import HeroArtwork from './HeroArtwork';

function Hero() {
  return (
    <section className="hero poster-texture" id="forside" aria-labelledby="hero-title">
      <div className="hero-content">
        <div className="eyebrow-row">
          <span>UNDER UDVIKLING</span>
          <span>SOUTH EASTERN BAKERY</span>
          <span>GLOBAL FLATBREADS</span>
        </div>
        <h1 id="hero-title">
          VERDENS BRØDTRADITIONER. SAMLET I ET NYT DANSK BAGERIBRAND.
        </h1>
        <p className="hero-intro">
          South Eastern Bakery er et nyt bageribrand under udvikling. Vi arbejder på en familie af
          fladbrød, pita, naan og andre street breads inspireret af brødtraditioner fra forskellige
          dele af verden og udviklet til foodservice, detail og moderne måltider.
        </p>
        <div className="hero-actions">
          <a className="button button-dark" href="#kontakt">
            Kontakt os om samarbejde
          </a>
          <a className="button button-outline" href="#broeduniverset">
            Se vores brødunivers
          </a>
        </div>
      </div>
      <HeroArtwork />
    </section>
  );
}

export default Hero;